<template>
  <div class="content" >
    <NavBar :navBlock='navBlock' :navtitle='navtitle'></NavBar>
    <div class="top_tance"></div>
    <div class="paddingContent">

        <div class="ListMenu">
          <el-form ref="form" class="searchForm">
            <el-form-item label="直播名稱">
              <el-input placeholder="請輸入直播名稱" v-model="searchLiveName"></el-input>
            </el-form-item>
            <el-form-item label="开始时间">
              <el-date-picker v-model="startTime" type="datetime"  placeholder="选择时间"></el-date-picker>
            </el-form-item>
          </el-form>
          <div class="MenuBtnWrap">
            <div class="btn" @click="search()">查询</div>
            <div class="btn" @click="startLiveFlag = true">发起直播</div>
            <div class="btn borderBtn" @click="reset">重置</div>
          </div>
        </div>

        <div class="tableWrap">
          <el-table height='660px' stripe :data="liveList" style="width:100%;" v-if="!!liveList.length">
            <template slot="empty">
            <div class="no-data-container">
              <img src="@/assets/images/common/no_data.png" alt="暂无数据" :style="{width:'244px',height:'139px'}">
            </div>
          </template>
            <el-table-column
              v-for="(item, index) in liveTable" :key="index"
              :prop="item.prop"
              :label="item.label"
              :width="item.width">
            </el-table-column>
            <el-table-column label="操作"  fixed="right">
              <template slot-scope="scope">
                <el-button v-if="scope.row.liveStatus == '进行中'"  @click="userToggleFlag = true" type="text">管理</el-button>
                <!-- <el-button @click="userToggleFlag = true" type="text">配置</el-button> -->
                <!-- <el-button v-if="scope.row.liveStatus == '进行中'"  @click="bossToggleLine()" type="text">切换线路</el-button> -->
                <el-button @click="ViewCom(scope.row.roomNumber)" type="text">查看评论</el-button>
                <el-button v-if="scope.row.liveStatus == '进行中'" @click="endLive()" type="text">结束直播</el-button>
                <el-button v-if="scope.row.liveStatus == '已结束'" @click="getBackLine(scope.row.oriLink)" type="text">查看回放鏈接</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="void_data" v-else>
            <img src="../../assets/images/common/icon_live_void.png">
          </div>
        </div>

        <div class="paging-block clearfix">
          <el-pagination class="paging fr"
            hide-on-single-page
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="10"
            :pager-count='5'
            layout="prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>

        <!-- 发起直播 -->
        <el-dialog 
            title="發起直播"
            :visible.sync="startLiveFlag" 
            class="propWrap" 
            :close-on-press-escape='false'
            :close-on-click-modal='false'
            width="560px">
          <div class ='prop-content' style="width:100%">
            <div style="height:60%;width:66%;margin:0 auto;display: flex; flex-direction:column;justify-content: center;align-items: flex-start;">
                <div style="display: flex; justify-content: flex-start; align-items: center;margin-bottom:20px">
                  <p style="width:60px;margin-right:20px;text-align: left">直播名称:</p>
                  <input
                    maxlength="50"
                    class="el-input__inner"
                    style="width:200px;"
                    type="text"
                    v-model="liveName"
                    placeholder="请输入直播名称"
                  >
                </div>
                <div style="display: flex; justify-content: flex-start; align-items: center;margin-bottom:20px">
                  <p style="width:100px;margin-right:10px;text-align: left">直播清晰度:</p>
                  <el-select v-model="definition" placeholder="请选择">
                    <el-option
                      v-for="item in definitionList" 
                      :key="item.definition"
                      :label="item.definitionName" 
                      :value="item.definition">
                    </el-option>
                  </el-select>
                </div>
                <div style="display: flex; justify-content: flex-start; align-items: center;margin-bottom:20px">
                  <p style="width:100px;margin-right:10px;text-align: left">线路地址:</p>
                  <el-select v-model="bossline" placeholder="请选择" @change="selectBossChange()">
                    <el-option
                      v-for="item in lineList" 
                      :key="item.hostKind"
                      :label="item.hostName" 
                      :value="item.hostKind">
                    </el-option>
                  </el-select>
                </div>
                <div style="display: flex; justify-content: flex-start; align-items: center;margin-bottom:20px">
                  <p style="margin-right:20px;width:60px;text-align: left">房间号:</p>
                  <!-- <el-input
                    placeholder="请生成房间号"
                    v-model="roomId"
                    type="text"
                    maxlength="12"
                  /> -->
                  <input
                    maxlength="100"
                    class="el-input__inner"
                    style="width:200px;"
                    type="text"
                    v-model="roomId"
                    placeholder="请生成房间号"
                    >
                  <div class="btn" style="margin-left: 20px;" @click="getRnadomFiveInt">生成房间号</div>
                </div>
                <div style="display: flex; justify-content: flex-start; align-items: center;">
                  <p style="width:60px;text-align: left">推流地址:</p>
                  <input maxlength="100" class="el-input__inner" style="width:200px; margin: 0 20px 0 20px" type="text" v-model="bossVideoURL">
                  <div class="btn hand new_btn" @click="createBossUrl()">生成地址</div>
                </div>
                <div style="display: flex; justify-content: flex-start; align-items: center;margin-top: 20px;">
                    <el-radio v-model="screenRadio" label="2">横屏</el-radio>
                    <el-radio v-model="screenRadio" label="1">竖屏</el-radio>
                </div>
                <div style="display: flex; justify-content: flex-start; align-items: center;margin-top: 20px;">
                  <p style="width:60px;text-align: left">是否推送:</p>
                    <el-switch
                      active-color="#6C3DEA"
                      v-model="pushFlag">
                    </el-switch>
                </div>

            </div>
            <div class="bottomBtn">
              <!--<div class="btn">取消</div>-->
              <div class="btn hand new_btn borderBtn" @click="closeStartLive">取消</div>

              <div class="btn hand new_btn" @click="startLive">发起直播</div>
            </div>
          </div>
        </el-dialog>
        
        <!-- 管理正在进行的直播 -->
        <div v-if="userToggleFlag" class="propWrap">
          <div class="prop-content mobile_show">
            <i class="iconfont icon-close fr hand" @click="closeProp"></i>
            <p class="prop-title normal_font" style="font-weight: 600;">管理</p>
            <div style="height:60%;width:80%;margin:0 auto;display: flex; flex-direction:column;justify-content: center;align-items: flex-start;">
                <div style="display: flex; justify-content: flex-start; align-items: center;margin-bottom:20px">
                  <p style="width:100px;margin-right:10px;text-align: left">线路地址:</p>
                  <el-select v-model="lineUrl" placeholder="请选择" @change="selectChange()">
                    <el-option
                      v-for="item in lineList" 
                      :key="item.hostKind"
                      :label="item.hostName" 
                      :value="item.hostKind">
                    </el-option>
                  </el-select>
                </div>

                <div style="display: flex; justify-content: flex-start; align-items: center;">
                  <p style="width:60px;text-align: left">播流地址:</p>
                  <input maxlength="100" class="el-input__inner" style="width:200px; margin: 0 20px 0 20px" type="text" v-model="videoURL">
                  <div class="btn hand new_btn" @click="generateLine()">生成线路</div>
                </div>

              <p style="margin-top:20px;">
                *如直播出现异常情况，点击生成地址可直接替换成备用地址
              </p>
            </div>
            <div class="bottomBtn">
              <!--<div class="btn">取消</div>-->
              <div class="btn hand new_btn borderBtn" @click="closeProp">取消</div>

              <div class="btn hand new_btn" @click="userToggleLine">确定</div>
            </div>
          </div>
        </div>
        <!-- 查看回放鏈接 -->
        <el-dialog 
            title="查看回放鏈接"
            :visible.sync="backLineFlag" 
            class="propWrap" 
            :close-on-press-escape='false'
            :close-on-click-modal='false'
            width="600px"
            style="z-index:1999"
          >
          <div class="line">
            <div style="height:60%;width:80%;margin:0 auto;display: flex; flex-direction:column;justify-content: center;align-items: flex-start;" v-if="standardDefinition">
                <div style="display: flex; justify-content: flex-start; align-items: center;width:100%;">
                  <p style="width:100px;text-align: left;flex-shrink:0">高清（mp4格式）:</p>
                    <el-input v-model="standardDefinition" style="width:320px;margin-left:18px;">
                      <div slot="append" @click="copyText" style="cursor:pointer">復製鏈接</div>
                    </el-input>
                  <!-- <div class="btn"  @click="copyText">確認修改</div> -->
                </div>

            </div>
            <div class="no_link" v-else>
              <img src="../../assets/images/common/icon_link.png">
              <div>回放鏈接還未生成，請稍後再看！</div>
            </div>
            <div class="bottomBtn">
              <div class="btn" @click="closeGetBack">{{ !!standardDefinition? '取消': '返回' }}</div>
            </div>
          </div>
      </el-dialog>
    </div>
    <DiaMess v-if="dialogVisible"></DiaMess>

  </div>
</template>

<script>
import NavBar from '@/components/navBar';
import DiaMess from '@/components/dialog';

export default {
  data () {
    return {
      navBlock: '直播',
      navtitle: '直播管理',
      roomId: '',
      roomIdFlag: true,
      liveList: [],
      liveTable: [
        {
          prop: 'streamName',
          label: '直播id',
          width: ''
        }, {
          prop: 'liveName',
          label: '直播名称',
          width: ''
        }, {
          prop: 'startTime',
          label: '开始时间',
          width: ''
        },{
          prop: 'endTime',
          label: '结束时间',
          width: '150'
        },{
          prop: 'userCount',
          label: '在线人数',
          width: '100'
        },{
          prop: 'liveStatus',
          label: '状态',
          width: '100'
        }
      ],
      startTime: '',
      currentPage: 1, // 分页
      total: 0,
      roleType: '',
      userToggleFlag: false,
      startLiveFlag: false,
      lineUrl:'', //线路地址
      videoURL: '',//备用播流地址
      bossVideoURL: '',//推流地址
      bossline: '', //推流线路地址
      pushFlag: true,
      toggleStep: 1,
      screenRadio: '2',
      dialogVisible: false,
      backLineFlag: false,
      standardDefinition:'',//标清回放链接
      liveName: '',
      searchLiveName: '',
      definition:'',
      definitionList:[],
      lineList:[]
    }
  },
  created(){

    this.roleType = localStorage.getItem('roleType')
    this.getDefinitionList()
    this.getLinelist()
    if ( this.roleType != null && this.roleType.indexOf('ROLE_GUEST')> -1) {

      this.getLiveList();

    } else {

      this.$router.push('/home');

    }
  },
  activated(){

    this.roleType = localStorage.getItem('roleType');

    if ((this.roleType != null) && (this.roleType.indexOf('ROLE_GUEST')) > -1 && (this.currentPage === 1)) {

      this.getLiveList();
    } else {

      this.$router.push('/home');

    }
  },
  destroyed(){
    this.$message.closeAll();
  },
  methods:{
    // 获取列表
    getLiveList() {
      let url = `/room/number/list?page=${this.currentPage-1}&size=10`;
      if(!!this.searchLiveName){
        url = `${url}&liveName=${this.searchLiveName}`;
      }
      if(!!this.startTime){
        let startTime = this.$formatDate(this.startTime);
        url = `${url}&startTime=${startTime}`;
      }
      this.$post(url, '', this.$GLOBAL.jsonConfig)
      .then((res) => {
        if (res.code === '00000') {
          res.data.list.forEach(v=>{
            v.startTime= this.$getTime(v.startTime)
            if (v.liveStatus == 1) {
              v.endTime = '--'
            } else {
              v.endTime= this.$getTime(v.endTime)
            }
            v.liveStatus = v.liveStatus == 1 ? '进行中' : '已结束'
          })
          this.total = res.data.total;
          this.liveList = res.data.list
        } else {
          this.$propMessage(res.message, 'error');
        }
      });
    },
    // 获取清晰度枚举数组
    getDefinitionList(){
      this.$get('/live/push/definition',this.$GLOBAL.jsonConfig).then(res=>{
        if(res.code === '00000'){
          this.definitionList=res.data.list
        }else{
          this.$propMessage(res.message, 'error');
        }
      })
    },
    // 获取直播线路枚举数组
    getLinelist(){
        this.$get('/live/push/line',this.$GLOBAL.jsonConfig).then(res=>{
          if(res.code === '00000'){
          this.lineList=res.data.list
        }else{
          this.$propMessage(res.message, 'error');
        }
        })
    },
    // 线路切换
    selectChange() {
      console.log(this.lineUrl)
      this.$get(`/getValue?lineValue=${this.lineUrl}`, this.$GLOBAL.jsonConfig)
        .then((res) => {
          if (res.code==='00000') {
            console.log('success')
          } else {
            this.$propMessage(res.message, 'error');
          };
        });
    },
    //切换推流线路地址
    selectBossChange() {
      console.log(this.bossline)
    },

    ViewCom (id) {
      this.$router.push(`/liveComment?id=${id}`);
    },

    //查看回放鏈接
    getBackLine(standardDefinition,){
      let _this = this;
      _this.backLineFlag = true;
      // _this.standardDefinition = 'https://baidu.com'
      _this.standardDefinition = standardDefinition;
    },

    getRnadomFiveInt(){
        //创建空数组
      var temp = [];
      //for循环来生成随机五个数组元素，有可能是五个||四个||其他
      for(var i = 0 ; i < 5 ; i ++){
        //生成一个random_int的变量来存放0-9的随机数
        var random_int = parseInt( Math.random() * 10 );
          //如果这个数组为0位||生成的随机数为0，random_int被赋值为random_int+0-9的随机数然后求模
        if( i === 0 && random_int === 0 ){
          random_int  = (parseInt( Math.random() * 10 ) + random_int) % 10;
        }
        //在temp空数组中添加随机数
          temp.push( random_int );
        }
        //输出数组，数组长度，并且输出数组的每一位直接添加-号
        // console.log(temp , temp.length , temp.join(""));
      this.roomId = temp.join("");
  },


    search () {
      let _this = this;
      if (!this.searchLiveName && !this.startTime) {
        _this.dialogVisible = true;
        _this.$propMessage('请输入搜索条件','error',function(){
          _this.dialogVisible = false;
        });
        return false;
      }
      _this.$message.closeAll();
      _this.currentPage = 1;
      _this.getLiveList();
    },
    //老板端线路切换
    bossToggleLine(){
      let _this = this;
      _this.$get(`/circuit?circuitStatus=1`, this.$GLOBAL.jsonConfig)
        .then((res) => {
          _this.dialogVisible = true;
          if (res.code === '00000') {
            _this.$propMessage('切换线路成功', 'success',
              function(){
                _this.dialogVisible = false;
              });
          } else {
            _this.$propMessage(res.message, 'error',
              function(){
                _this.dialogVisible = false;
              });
          };
        });
    },

    // 切换用户线路（确定）
    userToggleLine () {
      let _this = this;
      if (_this.videoURL == '') {
        _this.dialogVisible = true;
        _this.$propMessage('请先生成备用地址！','error',function(){
          _this.dialogVisible = false;
        });
        return false
      }
      let circuit = _this.videoURL.split('&auth_key=')[0];
      let authKey = _this.videoURL.split('&auth_key=')[1];
      let param = {
        circuit: circuit,
        authKey: authKey      }
      _this.$post(`/savecircuit`, param, _this.$GLOBAL.jsonConfig)
      .then((res) => {
        _this.dialogVisible = true;
        if (res.code === '00000') {
          _this.videoURL = '';
          _this.lineUrl = '';
          _this.userToggleFlag = false;
          _this.$propMessage('保存成功', 'success',
            function(){
              _this.dialogVisible = false;
            });

        } else {
          _this.$propMessage(res.message, 'error',
            function(){
              _this.dialogVisible = false;
            });
        }
      });

    },

    // 生成用户端路线
    generateLine () {
      let _this = this;
      if (_this.lineUrl === '') {
        _this.dialogVisible = true;
        _this.$propMessage('请先选择线路地址！','error',function(){
          _this.dialogVisible = false;
        });
        return false
      }
      _this.$get(`/echocircuit`, _this.$GLOBAL.jsonConfig)
        .then((res) => {
          if (res.code==='00000') {
            _this.videoURL = res.data;
          } else {
            _this.$propMessage(res.message, 'error');
          };
        });
    },
    // 生成推流地址
    createBossUrl () {
      let _this = this;
      if(this.liveName === ''){
        _this.$propMessage('请输入直播名称', 'error');
        return false
      }
      if (_this.definition == '') {
        _this.$propMessage('请输入清晰度', 'error');
        return false
      }
      if (_this.bossline === '') {
        _this.dialogVisible = true;
        _this.$propMessage('请先选择线路地址！','error',function(){
          _this.dialogVisible = false;
        });
        return false
      }
      if (_this.roomId == '') {
        _this.dialogVisible = true;
        _this.$propMessage('请先生成房间号','error',function(){
          _this.dialogVisible = false;
        });
        return false
      }
      let param = {
        circuit: _this.bossline,
        streamName : _this.roomId,
        liveName: this.liveName,
        definition : _this.definition
      };
      _this.$post(`/startPushOnline`, param, _this.$GLOBAL.jsonConfig)
        .then((res) => {
          if (res.code === '00000') {
            _this.bossVideoURL = res.data.pushUrl;
          } else if (res.code ==='80003') {
            _this.$propMessage('房间号已存在，请重新生成', 'error');
            _this.roomId = '';
          } else {
            _this.$propMessage(res.message, 'error');
          };
        });
    },
    // 发起直播
    startLive () {
      let _this = this;
      if(this.liveName === ''){
        _this.$propMessage('请输入直播名称', 'error');
        return false
      }
      if (_this.bossVideoURL === '') {
        _this.$propMessage('请先生成推流地址', 'error');
        return false
      }
      if (_this.roomId === '') {
        _this.$propMessage('请输入房间号', 'error');
        return false
      }
      let param = {
        liveName: this.liveName,
        screenStatus: Number(_this.screenRadio),
        jpushStatus: _this.pushFlag ? 'on' : 'off',
        streamName : _this.roomId,
      };
      _this.$post(`/startpullOnline`, param, _this.$GLOBAL.jsonConfig)
        .then((res) => {
          if (res.code==='00000') {
            _this.dialogVisible = true;
            _this.startLiveFlag = false;
            _this.bossline = '';
            _this.definition = '';
            _this.bossVideoURL = '';
            _this.roomId = '';
            _this.screenRadio = '2';
            _this.pushFlag = true;
            _this.currentPage = 1;
            _this.getLiveList();
            _this.$propMessage('发起直播成功', 'success',
              function(){
                _this.dialogVisible = false;
              });

          } else if (res.code ==='80003') {
            _this.$propMessage('房间号已存在，请重新生成', 'error');
            _this.roomId = '';
          } else {
            _this.dialogVisible = true;

            _this.startLiveFlag = false;
            _this.bossline = '';
            _this.definition = '';
            _this.bossVideoURL = '';
            _this.roomId = '';
            _this.pushFlag = true;
            _this.currentPage = 1;
            _this.getLiveList();
            _this.$propMessage(res.message, 'error',
              function(){
                _this.dialogVisible = false;
              });

          };
        });
    },
    // 结束直播
    endLive () {
      let _this = this;
      _this.$confirm('是否确认结束直播', '提示信息', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          center: true,
        closeOnClickModal: false
        }).then(() => {
          _this.$get(`/endRoomNo`, _this.$GLOBAL.jsonConfig)
            .then((res) => {
              _this.dialogVisible = true;
              if (res.code==='00000') {
                _this.$propMessage('结束直播成功', 'success',
                  function(){
                    _this.getLiveList();
                    _this.dialogVisible = false;
                  });

              } else {
                _this.$propMessage(res.message, 'error',
                  function(){
                    _this.dialogVisible = false;
                  });
              };
          });
        }).catch(() => {
        });
    },

    // 关闭配置窗口
    closeProp () {
      // 管理进行中的直播
      this.videoURL = '';
      this.lineUrl = '';
      this.userToggleFlag = false;
    },
    // 關閉回放鏈接彈窗
    closeGetBack(){
      this.backLineFlag = false;
    },
    // 关闭发起直播界面
    closeStartLive(){
      let _this = this;
      if(_this.roomId != '' || _this.bossVideoURL != '') {
        _this.$get(`/resetRoom/${_this.roomId}`, _this.$GLOBAL.jsonConfig)
        .then((res) => {
          if (res.code==='00000') {
            _this.dialogVisible = true;
            _this.bossline = '';
            _this.definition = '';
            _this.bossVideoURL = '';
            _this.roomId = '';
            _this.pushFlag = true;
            _this.screenRadio = '2';
            _this.startLiveFlag = false;
            _this.$propMessage('取消成功', 'success',
              function(){
                _this.dialogVisible = false;
              });

          } else {
            _this.bossline = '';
            _this.definition = '';
            _this.bossVideoURL = '';
            _this.roomId = '';
            _this.pushFlag = true;
            _this.screenRadio = '2';
            _this.startLiveFlag = false;
          };
        });
      } else {
        _this.bossline = '';
        _this.definition = '';
        _this.bossVideoURL = '';
        _this.roomId = '';
        _this.pushFlag = true;
        _this.screenRadio = '2';
        _this.startLiveFlag = false;
      }
    },
    // 分页
    handleCurrentChange (val) {
      this.currentPage = val;
      this.getLiveList();
    },

    reset(){
      this.searchLiveName = '';
      this.startTime = '';
      this.currentPage = 1;
      this.getLiveList();
    },
    copyText(){
      let _this = this;
      const textArea = document.createElement('textarea');
      textArea.value = _this.standardDefinition;
      // 将 textarea 元素添加到 DOM 中
      document.body.appendChild(textArea);
      // 选中文本
      textArea.select();
      // 执行复制命令
      document.execCommand('copy');
      // 移除 textarea 元素
      document.body.removeChild(textArea);
      _this.dialogVisible = true;
      _this.backLineFlag = false
      _this.$propMessage('複製成功', 'success',  function() {
          _this.dialogVisible = false;
      });
    }
  },
  components: {
    NavBar,
    DiaMess,
  }
};
</script>

<style lang="less" scoped>
    .line{
      /deep/ .el-input__inner{
        border: 1px solid rgba(147, 142, 164, 0.50);
        background: rgba(242, 240, 247, 1);
        color: rgba(108, 61, 234, 1);
        // text-decoration: underline;text-decoration-color: rgba(108, 61, 234, 1);
      }
      /deep/ .el-input-group__append{
        border: 1px solid rgba(147, 142, 164, 0.50);
        background: rgba(242, 240, 247, 1);
        color: rgba(108, 61, 234, 1);
        border-left: 0px;
      }
    }
  .content{
    .before:before {
      content: '*';
      color: #6C3DEA ;
      margin-right: 4px;
    }
    .top_tance {
      padding-top: 0.8rem;

      @media (max-width: 768px) {
        padding-top: 22px;
      }

      @media (max-width: 420px) {
        padding-top: 62px;
      }

    }

    .paddingContent {
      height: calc(100% - 88px);
      padding: 0.4rem 0.4rem;
      background-color: #ffffff;

      @media (max-width: 768px) {
        height: calc(100% - 62px);
      }

      .addBtn {
        margin: 0.2rem 0;
        cursor: pointer;

        @media (max-width: 420px) {
          margin-top: 0.3rem;
          margin-bottom: 10px;
        }

      }

      .btn {
        @media (max-width: 420px) {
          width: 1.3rem;
          height: 0.5rem;
          line-height: 0.5rem;
          font-size: 12px;
        }
      }

      .tableWrap {
        position: relative;
        width: 100%;
        height: calc(100% - 152px);
        overflow: hidden;
        word-break: break-all;

        @media (max-width: 768px) {
          height: calc(100% - 92px);
        }

        @media (max-width: 420px) {
          height: calc(100% - 112px);
        }

      }

      .el-table {
        @media (max-width: 420px) {
          min-width: 200%;
        }
      }

    }

    .paging-block {
      margin: 0.2rem 0;

      @media (max-width: 420px) {
        margin: 0.3rem 0;
      }

    }

    .propWrap {
      .prop-content {
       overflow: auto;
       .el-select{
        width:100%;
       }
        img {
          // width: 38%;
          width: 70%;
          // max-height:5rem;
          // max-height:76%;
          @media (max-width: 420px) {
            width: 50%;
          }

        }
        .no_link{
          text-align: center;
          img{
            margin-bottom: 24px;
            width: 145px;
            height: 67px;
          }
          div{
            color: #292929;
            font-size: 16px;
          }
        }
      }
    }

  }
  .void_data{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 244px;
    height: 139px;
    img{
      width: 100%;
      height: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/live/liveList.vue